<script lang="ts">
  import type { SvelteComponentDev } from "svelte/internal"

  export let icon: SvelteComponentDev
  export let label: string
  export let fill: string | undefined = undefined
  export let disabled: boolean = false
  export function focus() {
    if (button) {
      button.focus()
    }
  }

  let button: HTMLButtonElement
</script>

<button
  on:click
  class={$$props.class}
  aria-label={label}
  {disabled}
  bind:this={button}
>
  <svelte:component
    this={icon}
    class="iconButton"
    style={fill ? `fill:${fill}` : ""}
  />
</button>

<style lang="scss">
  button {
    width: 32px;
    height: 32px;
    border: none;
    background: transparent;
    padding: 8px;

    :global(.iconButton) {
      width: 16px;
      height: 16px;
    }
  }
</style>
